module.exports = __webpack_public_path__ + "img/big-band-theory-3.b473a4a2.jpg";